import {Component, Input, OnInit} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import {RestaurantService} from "../../services/restaurant.service";
import {MyStorageService} from "../../services/my-storage.service";
import {Constants} from "../../utils/constants";
import {ClosableComponent} from "../../models/closable-component";


@Component({
  selector: 'app-restaurant-select-modal',
  templateUrl: './restaurant-select-modal.component.html',
  styleUrls: ['./restaurant-select-modal.component.scss']
})
export class RestaurantSelectModalComponent extends ClosableComponent implements OnInit {
  @Input() restaurants: any[];
  public selectedRestaurantHistoryId;

  constructor(
    public bsModalRef: BsModalRef,
    private restaurantService: RestaurantService,
    private storageService: MyStorageService
  ) {
    super(bsModalRef)
  }

  ngOnInit() {}

  restaurantSelected(restaurant: any){
    this.selectedRestaurantHistoryId = restaurant.historyId;
    this.setRestaurant(restaurant);
  }

  setRestaurant(restaurant: any) {
    this.storageService.saveToCookies(Constants.STORAGE_KEYS.RESTAURANT, this.selectedRestaurantHistoryId);
    this.storageService.saveToCookies(Constants.STORAGE_KEYS.LANGUAGE, restaurant.defaultLanguage.toLowerCase());
    this.closeWithResponse(true)
  }

}
